export default class FeatureTables {
	ready() {

		const TABLES = document.querySelectorAll('.mtt-feature-table-wrap');
		if (TABLES.length > 0) {
			for (let i = 0; i < TABLES.length; i++) {
				new FeatureTable(TABLES[i]);
			}
		}
	}
}

class FeatureTable {

	constructor(WRAPPER) {
		this.WRAPPER = WRAPPER;
		this.addEventListeners();
	}

	addEventListeners() {
		const NAV_ITEMS = this.WRAPPER.querySelectorAll('.mtt-feature-table__nav-item');

		for (let i = 0; i < NAV_ITEMS.length; i++) {
			const NAV_ITEM = NAV_ITEMS[i];

			NAV_ITEM.addEventListener('click', event => {
				if (event.currentTarget.classList.contains('mtt-feature-table__nav-item--active')) {
					return;
				}

				this.changeColumn(event);
				this.changeActiveNav(event);
			}, false);
		}
	}

	getNavID(event) {
		return event.currentTarget.getAttribute('data-nav-id');
	}

	getColumnByID(id) {
		return this.WRAPPER.querySelector(`.mtt-feature-table__column[data-column-id="${id}"]`)
	}

	getActiveColumn() {
		return this.WRAPPER.querySelector('.mtt-feature-table__column--active');
	}

	getActiveNavItem() {
		return this.WRAPPER.querySelector('.mtt-feature-table__nav-item--active');
	}

	changeActiveNav(event) {
		const ACTIVE_NAV = this.getActiveNavItem();
		const CLICKED_NAV = event.currentTarget;

		ACTIVE_NAV.classList.remove('mtt-feature-table__nav-item--active');
		CLICKED_NAV.classList.add('mtt-feature-table__nav-item--active');
	}

	changeColumn(event) {
		const COLUMN_ID = this.getNavID(event);
		const ACTIVE_COLUMN = this.getActiveColumn();
		const NEW_COLUMN = this.getColumnByID(COLUMN_ID);

		ACTIVE_COLUMN.classList.remove('mtt-feature-table__column--active');
		NEW_COLUMN.classList.add('mtt-feature-table__column--active');
	}
}